import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { RegisterFormNaturalPersonComponent } from '../../../main/register/register-form-natural-person/register-form-natural-person.component';
import { CandidateService } from 'src/app/services/candidate.service';
import { AlertService } from 'src/app/services/alert.service';
import { UserService } from 'src/app/services/user.service';
import { GetCandidate } from 'src/app/models/candidate/get-candidate';
import { GetAddress } from 'src/app/models/security/register-request';

@Component({
  selector: 'app-candidate-details-admin',
  standalone: true,
  imports: [CommonModule, RegisterFormNaturalPersonComponent],
  templateUrl: './candidate-details-admin.component.html',
  styleUrls: ['./candidate-details-admin.component.css']
})
export class CandidateDetailsAdminComponent implements OnInit {
  
  isLoading: boolean = false;
  isFound: boolean = false;
  candidateId: number = 0;
  candidate: GetCandidate | null = null;
  addresses: GetAddress[] = [];

  userId: number = 0;

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private candidateService = inject(CandidateService);
  private alertService = inject(AlertService);
  private userService = inject(UserService);

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.candidateId = +params['id'];
        this.getCandidateData();
      } else {
        this.router.navigate(['/admin/candidates']);
      }
    });
  }

  getCandidateData(): void {
    this.isLoading = true;
    
    this.candidateService.getCandidateById(this.candidateId).subscribe({
      next: (res) => {
        if (res) {
          this.candidate = res;
          this.isFound = true;
          this.userId = this.candidate.userId;
          this.getAddresses();
        }
      },
      error: (err) => {
        if (err) {
          this.alertService.showErrorAlert(err[0]);
        } else {
          this.alertService.showErrorAlert('Error al consultar la información del candidato');
        }
        this.router.navigate(['/admin/candidates']);
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  getAddresses(): void {
    this.isLoading = true;
    
    this.userService.getAddresses(this.userId).subscribe({
      next: (res) => {
        this.addresses = res;
      },
      error: (err) => {
        if (err) {
          this.alertService.showErrorAlert(err[0]);
        } else {
          this.alertService.showErrorAlert('Error al consultar las direcciones del candidato');
        }
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  goBack(): void {
    this.router.navigate(['/admin/candidates']);
  }
}
